// import { useState, useEffect, useRef, useCallback } from "react";
// import { useParams } from "react-router-dom";
// import { useSelector } from "react-redux";
// import { selectUser } from "../redux/authSlice";
// import { useMessages } from "../hooks/useMessages";
// import { useToast } from "../context/ToastContext";
// import { apiJson } from "../api/apiClient";
// import "../styles/ChatBubble.css";

// // Typing indicator component
// const TypingDots = () => (
//   <div className="typing-indicator">
//     <div className="typing-avatar">🏠</div>
//     <div className="typing-bubble">
//       {[0, 1, 2].map((i) => (
//         <span key={i} className="typing-dot" />
//       ))}
//     </div>
//   </div>
// );

// // Message bubble component
// const MessageBubble = ({ message, timeStr, isNew }) => {
//   const isUser = message.sender === "user";
  
//   return (
//     <div className={`message-bubble ${isUser ? 'message-bubble-user' : 'message-bubble-admin'}`}>
//       {!isUser && <div className="message-avatar">🏠</div>}
//       <div className="message-content">
//         <div className="message-bubble-text">
//           {message.message}
//         </div>
//         <div className={`message-meta ${isUser ? 'message-meta-user' : 'message-meta-admin'}`}>
//           <span className="message-time">{timeStr(message.created_at)}</span>
//           {isUser && <span className="message-tick">✓✓</span>}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default function ChatBubble() {
//   // Rendered inside TenantLayout's <Outlet />, so :tenant is still
//   // readable here even though this component isn't itself a route.
//   const { tenant } = useParams();
//   const user = useSelector(selectUser);
//   const { showToast } = useToast();
//   const {
//     messages, unread, loading, sending,
//     loadMessages, sendMessage, setUnread, setOpen,
//   } = useMessages(tenant, user);

//   const [isOpen, setIsOpen] = useState(false);
//   const [input, setInput] = useState("");
//   const [animOut, setAnimOut] = useState(false);
//   const [isAdminTyping, setIsAdminTyping] = useState(false);
//   const [newMsgIds, setNewMsgIds] = useState(new Set());
//   const [bubblePop, setBubblePop] = useState(false);
//   const [inputFocused, setInputFocused] = useState(false);

//   const bottomRef = useRef(null);
//   const inputRef = useRef(null);
//   const prevUnread = useRef(0);
//   const prevMsgCount = useRef(0);
//   const prevUserIdRef = useRef(null);
//   const typingPollRef = useRef(null);
//   const userTypingTimer = useRef(null);

//   // Reset on user change
//   useEffect(() => {
//     const uid = user?.id ?? null;
//     if (prevUserIdRef.current !== null && prevUserIdRef.current !== uid) {
//       prevUnread.current = 0;
//       prevMsgCount.current = 0;
//       setIsOpen(false);
//       setInput("");
//       setIsAdminTyping(false);
//       setNewMsgIds(new Set());
//     }
//     prevUserIdRef.current = uid;
//   }, [user?.id]);

//   // Poll admin typing
//   const startTypingPoll = useCallback(() => {
//     if (typingPollRef.current) clearInterval(typingPollRef.current);
//     typingPollRef.current = setInterval(async () => {
//       if (!user?.token || !tenant) return;
//       try {
//         const data = await apiJson(tenant, "/messages/typing", {
//           headers: { Authorization: `Bearer ${user.token}` },
//         });
//         setIsAdminTyping(data.typing === true);
//       } catch (_) {}
//     }, 2000);
//   }, [user?.token, tenant]);

//   const stopTypingPoll = useCallback(() => {
//     if (typingPollRef.current) {
//       clearInterval(typingPollRef.current);
//       typingPollRef.current = null;
//     }
//     setIsAdminTyping(false);
//   }, []);

//   // Cleanup
//   useEffect(() => {
//     return () => {
//       stopTypingPoll();
//       clearTimeout(userTypingTimer.current);
//     };
//   }, [stopTypingPoll]);

//   // Send user typing signal
//   const sendUserTypingSignal = useCallback(() => {
//     if (!user?.token || !tenant) return;
//     clearTimeout(userTypingTimer.current);
//     userTypingTimer.current = setTimeout(() => {
//       apiJson(tenant, "/messages/typing", {
//         method: "POST",
//         headers: { Authorization: `Bearer ${user.token}` },
//       }).catch(() => {});
//     }, 300);
//   }, [user?.token, tenant]);

//   // Animate new admin messages
//   useEffect(() => {
//     const newCount = messages.length;
//     if (newCount > prevMsgCount.current && prevMsgCount.current > 0) {
//       const newAdminMsgs = messages.slice(prevMsgCount.current).filter(m => m.sender !== "user");
//       if (newAdminMsgs.length > 0) {
//         setIsAdminTyping(false);
//         setNewMsgIds(prev => {
//           const next = new Set(prev);
//           newAdminMsgs.forEach(m => next.add(m.id));
//           return next;
//         });
//         setTimeout(() => {
//           setNewMsgIds(prev => {
//             const next = new Set(prev);
//             newAdminMsgs.forEach(m => next.delete(m.id));
//             return next;
//           });
//         }, 600);
//       }
//     }
//     prevMsgCount.current = newCount;
//   }, [messages]);

//   // Toast on new unread
//   useEffect(() => {
//     if (!isOpen && unread > prevUnread.current) {
//       showToast("💬 New message from Support", "info", 5000);
//       setBubblePop(true);
//       setTimeout(() => setBubblePop(false), 600);
//     }
//     prevUnread.current = unread;
//   }, [unread, isOpen, showToast]);

//   // Scroll to bottom
//   useEffect(() => {
//     if (isOpen && bottomRef.current) {
//       bottomRef.current.scrollIntoView({ behavior: "smooth" });
//     }
//   }, [messages, isOpen, isAdminTyping]);

//   // Open chat
//   const handleOpen = useCallback(() => {
//     setAnimOut(false);
//     setIsOpen(true);
//     setOpen(true);
//     loadMessages();
//     setUnread(0);
//     startTypingPoll();
//     setTimeout(() => inputRef.current?.focus(), 300);
//   }, [loadMessages, setUnread, setOpen, startTypingPoll]);

//   // Close chat
//   const handleClose = useCallback(() => {
//     setAnimOut(true);
//     setOpen(false);
//     stopTypingPoll();
//     setTimeout(() => {
//       setIsOpen(false);
//       setAnimOut(false);
//     }, 220);
//   }, [setOpen, stopTypingPoll]);

//   // Send message
//   const handleSend = useCallback(async () => {
//     const text = input.trim();
//     if (!text || sending) return;
//     setInput("");
//     clearTimeout(userTypingTimer.current);
//     const ok = await sendMessage(text);
//     if (ok) {
//       setTimeout(() => bottomRef.current?.scrollIntoView({ behavior: "smooth" }), 80);
//     }
//   }, [input, sending, sendMessage]);

//   const handleKeyDown = (e) => {
//     if (e.key === "Enter" && !e.shiftKey) {
//       e.preventDefault();
//       handleSend();
//     }
//   };

//   const handleInputChange = (e) => {
//     setInput(e.target.value);
//     if (e.target.value.trim()) sendUserTypingSignal();
//   };

//   const formatTime = (date) => {
//     return date
//       ? new Date(date).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" })
//       : "";
//   };

//   if (!user?.token || !tenant) return null;

//   return (
//     <>
//       {/* Chat Panel */}
//       {isOpen && (
//         <div className={`chat-container ${animOut ? 'chat-container-closing' : 'chat-container-open'}`}>
//           {/* Header */}
//           <div className="chat-header">
//             <div className="chat-avatar">
//               <div className="chat-avatar-icon">🏠</div>
//             </div>

//             <div className="chat-info">
//               <div className="chat-title">Support Chat</div>
//               <div className={`chat-status ${isAdminTyping ? 'chat-status-typing' : 'chat-status-online'}`}>
//                 {isAdminTyping ? (
//                   <span className="chat-typing-indicator">
//                     <span className="chat-typing-text">Support is typing</span>
//                     <span className="chat-typing-dots">
//                       {[0, 1, 2].map(i => (
//                         <span key={i} className="chat-typing-dot" />
//                       ))}
//                     </span>
//                   </span>
//                 ) : (
//                   <>
//                     <span className="chat-online-pulse" />
//                     Online · Replies within an hour
//                   </>
//                 )}
//               </div>
//             </div>

//             <button onClick={handleClose} className="chat-close-btn">
//               ×
//             </button>
//           </div>

//           {/* Messages */}
//           <div className="chat-messages">
//             {loading && (
//               <div className="chat-loading">
//                 <div className="chat-loading-icon">💬</div>
//                 Loading messages...
//               </div>
//             )}

//             {!loading && messages.length === 0 && (
//               <div className="chat-empty">
//                 <div className="chat-empty-icon">👋</div>
//                 <div className="chat-empty-title">Hi {user?.name?.split(" ")[0]}!</div>
//                 <div className="chat-empty-message">
//                   Have a question about your booking?<br />We typically reply within an hour. 🕐
//                 </div>
//               </div>
//             )}

//             {messages.reduce((acc, msg, idx) => {
//               const date = msg.created_at
//                 ? new Date(msg.created_at).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })
//                 : null;
//               const prevDate = idx > 0 && messages[idx - 1].created_at
//                 ? new Date(messages[idx - 1].created_at).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })
//                 : null;
              
//               if (date && date !== prevDate) {
//                 acc.push(
//                   <div key={`sep-${idx}`} className="chat-date-separator">
//                     <div className="chat-date-line" />
//                     <span className="chat-date-text">{date}</span>
//                     <div className="chat-date-line" />
//                   </div>
//                 );
//               }
//               acc.push(
//                 <MessageBubble
//                   key={msg.id}
//                   message={msg}
//                   timeStr={formatTime}
//                   isNew={newMsgIds.has(msg.id)}
//                 />
//               );
//               return acc;
//             }, [])}

//             {/* Real typing indicator */}
//             {isAdminTyping && <TypingDots />}

//             <div ref={bottomRef} />
//           </div>

//           {/* Input Area */}
//           <div className="chat-input-area">
//             <textarea
//               ref={inputRef}
//               className={`chat-textarea ${inputFocused ? 'chat-textarea-focused' : ''}`}
//               value={input}
//               onChange={handleInputChange}
//               onKeyDown={handleKeyDown}
//               onFocus={() => setInputFocused(true)}
//               onBlur={() => setInputFocused(false)}
//               placeholder="Type a message..."
//               rows={1}
//             />
//             <button
//               onClick={handleSend}
//               disabled={sending || !input.trim()}
//               className={`chat-send-btn ${sending || !input.trim() ? 'chat-send-btn-disabled' : 'chat-send-btn-active'}`}
//             >
//               {sending ? "⏳" : "➤"}
//             </button>
//           </div>

//           {/* Keyboard hint */}
//           {inputFocused && input.trim() && (
//             <div className="chat-keyboard-hint">
//               Press <kbd>Enter</kbd> to send · <kbd>Shift+Enter</kbd> for newline
//             </div>
//           )}
//         </div>
//       )}

//       {/* Floating Bubble Button */}
//       <button
//         onClick={isOpen ? handleClose : handleOpen}
//         className={`chat-floating-btn 
//           ${isOpen ? 'chat-floating-btn-open' : 'chat-floating-btn-closed'} 
//           ${bubblePop ? 'chat-floating-btn-pulse' : ''} 
//           ${unread > 0 && !isOpen ? 'chat-floating-btn-pulse-animation' : ''}`}
//       >
//         {!isOpen && <span className="chat-floating-pulse-ring" />}
//         <span className={`chat-floating-icon ${isOpen ? 'chat-floating-icon-rotated' : 'chat-floating-icon-normal'}`}>
//           {isOpen ? "×" : "💬"}
//         </span>
//         {!isOpen && unread > 0 && (
//           <span className="chat-unread-badge">
//             {unread > 9 ? "9+" : unread}
//           </span>
//         )}
//       </button>
//     </>
//   );
// }


import { useState, useEffect, useRef, useCallback } from "react";
import { useParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useMessages } from "../hooks/useMessages";
import { useToast } from "../context/ToastContext";
import { apiJson } from "../api/apiClient";
import "../styles/ChatBubble.css";

// Typing indicator component
const TypingDots = () => (
  <div className="typing-indicator">
    <div className="typing-avatar">🏠</div>
    <div className="typing-bubble">
      {[0, 1, 2].map((i) => (
        <span key={i} className="typing-dot" />
      ))}
    </div>
  </div>
);

// Message bubble component
const MessageBubble = ({ message, timeStr, isNew }) => {
  const isUser = message.sender === "user";

  return (
    <div className={`message-bubble ${isUser ? 'message-bubble-user' : 'message-bubble-admin'}`}>
      {!isUser && <div className="message-avatar">🏠</div>}
      <div className="message-content">
        <div className="message-bubble-text">
          {message.message}
        </div>
        <div className={`message-meta ${isUser ? 'message-meta-user' : 'message-meta-admin'}`}>
          <span className="message-time">{timeStr(message.created_at)}</span>
          {isUser && <span className="message-tick">✓✓</span>}
        </div>
      </div>
    </div>
  );
};

export default function ChatBubble() {
  // Rendered inside TenantLayout's <Outlet />, so :tenant is still
  // readable here even though this component isn't itself a route.
  const { tenant } = useParams();
  const { user } = useAuth();
  const { showToast } = useToast();
  const {
    messages, unread, loading, sending,
    loadMessages, sendMessage, setUnread, setOpen,
  } = useMessages(tenant, user);

  const [isOpen, setIsOpen] = useState(false);
  const [input, setInput] = useState("");
  const [animOut, setAnimOut] = useState(false);
  const [isAdminTyping, setIsAdminTyping] = useState(false);
  const [newMsgIds, setNewMsgIds] = useState(new Set());
  const [bubblePop, setBubblePop] = useState(false);
  const [inputFocused, setInputFocused] = useState(false);

  const bottomRef = useRef(null);
  const inputRef = useRef(null);
  const prevUnread = useRef(0);
  const prevMsgCount = useRef(0);
  const prevUserIdRef = useRef(null);
  const typingPollRef = useRef(null);
  const userTypingTimer = useRef(null);

  // Reset on user change — this already covers the tenant-switch case too:
  // AuthContext clears `user` the instant the tenant in the URL changes
  // (see AuthContext.jsx), so `user?.id` transitions to null right along
  // with a real logout, and this effect resets the chat panel either way.
  useEffect(() => {
    const uid = user?.id ?? null;
    if (prevUserIdRef.current !== null && prevUserIdRef.current !== uid) {
      prevUnread.current = 0;
      prevMsgCount.current = 0;
      setIsOpen(false);
      setInput("");
      setIsAdminTyping(false);
      setNewMsgIds(new Set());
    }
    prevUserIdRef.current = uid;
  }, [user?.id]);

  // Poll admin typing
  const startTypingPoll = useCallback(() => {
    if (typingPollRef.current) clearInterval(typingPollRef.current);
    typingPollRef.current = setInterval(async () => {
      if (!user?.token || !tenant) return;
      try {
        const data = await apiJson(tenant, "/messages/typing", {
          headers: { Authorization: `Bearer ${user.token}` },
        });
        setIsAdminTyping(data.typing === true);
      } catch (_) {}
    }, 2000);
  }, [user?.token, tenant]);

  const stopTypingPoll = useCallback(() => {
    if (typingPollRef.current) {
      clearInterval(typingPollRef.current);
      typingPollRef.current = null;
    }
    setIsAdminTyping(false);
  }, []);

  // Cleanup
  useEffect(() => {
    return () => {
      stopTypingPoll();
      clearTimeout(userTypingTimer.current);
    };
  }, [stopTypingPoll]);

  // Send user typing signal
  const sendUserTypingSignal = useCallback(() => {
    if (!user?.token || !tenant) return;
    clearTimeout(userTypingTimer.current);
    userTypingTimer.current = setTimeout(() => {
      apiJson(tenant, "/messages/typing", {
        method: "POST",
        headers: { Authorization: `Bearer ${user.token}` },
      }).catch(() => {});
    }, 300);
  }, [user?.token, tenant]);

  // Animate new admin messages
  useEffect(() => {
    const newCount = messages.length;
    if (newCount > prevMsgCount.current && prevMsgCount.current > 0) {
      const newAdminMsgs = messages.slice(prevMsgCount.current).filter(m => m.sender !== "user");
      if (newAdminMsgs.length > 0) {
        setIsAdminTyping(false);
        setNewMsgIds(prev => {
          const next = new Set(prev);
          newAdminMsgs.forEach(m => next.add(m.id));
          return next;
        });
        setTimeout(() => {
          setNewMsgIds(prev => {
            const next = new Set(prev);
            newAdminMsgs.forEach(m => next.delete(m.id));
            return next;
          });
        }, 600);
      }
    }
    prevMsgCount.current = newCount;
  }, [messages]);

  // Toast on new unread
  useEffect(() => {
    if (!isOpen && unread > prevUnread.current) {
      showToast("💬 New message from Support", "info", 5000);
      setBubblePop(true);
      setTimeout(() => setBubblePop(false), 600);
    }
    prevUnread.current = unread;
  }, [unread, isOpen, showToast]);

  // Scroll to bottom
  useEffect(() => {
    if (isOpen && bottomRef.current) {
      bottomRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages, isOpen, isAdminTyping]);

  // Open chat
  const handleOpen = useCallback(() => {
    setAnimOut(false);
    setIsOpen(true);
    setOpen(true);
    loadMessages();
    setUnread(0);
    startTypingPoll();
    setTimeout(() => inputRef.current?.focus(), 300);
  }, [loadMessages, setUnread, setOpen, startTypingPoll]);

  // Close chat
  const handleClose = useCallback(() => {
    setAnimOut(true);
    setOpen(false);
    stopTypingPoll();
    setTimeout(() => {
      setIsOpen(false);
      setAnimOut(false);
    }, 220);
  }, [setOpen, stopTypingPoll]);

  // Send message
  const handleSend = useCallback(async () => {
    const text = input.trim();
    if (!text || sending) return;
    setInput("");
    clearTimeout(userTypingTimer.current);
    const ok = await sendMessage(text);
    if (ok) {
      setTimeout(() => bottomRef.current?.scrollIntoView({ behavior: "smooth" }), 80);
    }
  }, [input, sending, sendMessage]);

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  const handleInputChange = (e) => {
    setInput(e.target.value);
    if (e.target.value.trim()) sendUserTypingSignal();
  };

  const formatTime = (date) => {
    return date
      ? new Date(date).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" })
      : "";
  };

  if (!user?.token || !tenant) return null;

  return (
    <>
      {/* Chat Panel */}
      {isOpen && (
        <div className={`chat-container ${animOut ? 'chat-container-closing' : 'chat-container-open'}`}>
          {/* Header */}
          <div className="chat-header">
            <div className="chat-avatar">
              <div className="chat-avatar-icon">🏠</div>
            </div>

            <div className="chat-info">
              <div className="chat-title">Support Chat</div>
              <div className={`chat-status ${isAdminTyping ? 'chat-status-typing' : 'chat-status-online'}`}>
                {isAdminTyping ? (
                  <span className="chat-typing-indicator">
                    <span className="chat-typing-text">Support is typing</span>
                    <span className="chat-typing-dots">
                      {[0, 1, 2].map(i => (
                        <span key={i} className="chat-typing-dot" />
                      ))}
                    </span>
                  </span>
                ) : (
                  <>
                    <span className="chat-online-pulse" />
                    Online · Replies within an hour
                  </>
                )}
              </div>
            </div>

            <button onClick={handleClose} className="chat-close-btn">
              ×
            </button>
          </div>

          {/* Messages */}
          <div className="chat-messages">
            {loading && (
              <div className="chat-loading">
                <div className="chat-loading-icon">💬</div>
                Loading messages...
              </div>
            )}

            {!loading && messages.length === 0 && (
              <div className="chat-empty">
                <div className="chat-empty-icon">👋</div>
                <div className="chat-empty-title">Hi {user?.name?.split(" ")[0]}!</div>
                <div className="chat-empty-message">
                  Have a question about your booking?<br />We typically reply within an hour. 🕐
                </div>
              </div>
            )}

            {messages.reduce((acc, msg, idx) => {
              const date = msg.created_at
                ? new Date(msg.created_at).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })
                : null;
              const prevDate = idx > 0 && messages[idx - 1].created_at
                ? new Date(messages[idx - 1].created_at).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })
                : null;

              if (date && date !== prevDate) {
                acc.push(
                  <div key={`sep-${idx}`} className="chat-date-separator">
                    <div className="chat-date-line" />
                    <span className="chat-date-text">{date}</span>
                    <div className="chat-date-line" />
                  </div>
                );
              }
              acc.push(
                <MessageBubble
                  key={msg.id}
                  message={msg}
                  timeStr={formatTime}
                  isNew={newMsgIds.has(msg.id)}
                />
              );
              return acc;
            }, [])}

            {/* Real typing indicator */}
            {isAdminTyping && <TypingDots />}

            <div ref={bottomRef} />
          </div>

          {/* Input Area */}
          <div className="chat-input-area">
            <textarea
              ref={inputRef}
              className={`chat-textarea ${inputFocused ? 'chat-textarea-focused' : ''}`}
              value={input}
              onChange={handleInputChange}
              onKeyDown={handleKeyDown}
              onFocus={() => setInputFocused(true)}
              onBlur={() => setInputFocused(false)}
              placeholder="Type a message..."
              rows={1}
            />
            <button
              onClick={handleSend}
              disabled={sending || !input.trim()}
              className={`chat-send-btn ${sending || !input.trim() ? 'chat-send-btn-disabled' : 'chat-send-btn-active'}`}
            >
              {sending ? "⏳" : "➤"}
            </button>
          </div>

          {/* Keyboard hint */}
          {inputFocused && input.trim() && (
            <div className="chat-keyboard-hint">
              Press <kbd>Enter</kbd> to send · <kbd>Shift+Enter</kbd> for newline
            </div>
          )}
        </div>
      )}

      {/* Floating Bubble Button */}
      <button
        onClick={isOpen ? handleClose : handleOpen}
        className={`chat-floating-btn 
          ${isOpen ? 'chat-floating-btn-open' : 'chat-floating-btn-closed'} 
          ${bubblePop ? 'chat-floating-btn-pulse' : ''} 
          ${unread > 0 && !isOpen ? 'chat-floating-btn-pulse-animation' : ''}`}
      >
        {!isOpen && <span className="chat-floating-pulse-ring" />}
        <span className={`chat-floating-icon ${isOpen ? 'chat-floating-icon-rotated' : 'chat-floating-icon-normal'}`}>
          {isOpen ? "×" : "💬"}
        </span>
        {!isOpen && unread > 0 && (
          <span className="chat-unread-badge">
            {unread > 9 ? "9+" : unread}
          </span>
        )}
      </button>
    </>
  );
}
